import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function DuserPrivateRoute({ allowedRoles, allowedTypes }) {
  const dUserData = JSON.parse(localStorage.getItem("dUser"));
  
  const dUserRole = dUserData?.role;
  const dUserType = dUserData?.accountType;
  
  // Check if role and type are permitted
  if (!dUserData || !allowedRoles.includes(dUserRole) || !allowedTypes.includes(dUserType)) {
    return <Navigate to="/HomePage" />;
  }

  return <Outlet />;
}

export default DuserPrivateRoute;